import { useTranslation } from 'react-i18next';
import {
  ErrorModal,
  PageContainer,
  PageFooter,
  PageHeader,
} from '../../../shared_components';
import {
  Flex,
  NumberInput,
  SegmentedControl,
  Space,
  Stack,
  TextInput,
} from '@mantine/core';
import classes from '../../../app.module.css';
import { useForm, zodResolver } from '@mantine/form';
import { Gender, userInfo } from '@web/common';
import { useEffect, useState } from 'react';
import { useKeycloakStore, useUserDataStore } from '../../../shared_stores';
import { z } from 'zod';

export const EditHealthData = () => {
  const { t } = useTranslation(['common']);
  const [isValid, setIsValid] = useState(false);
  const userDataStore = useUserDataStore();
  const kcStore = useKeycloakStore();
  const [displayError, setDisplayError] = useState(false);
  const form = useForm<z.input<typeof userInfo>>({
    initialValues: userDataStore.userInfo,
    validateInputOnBlur: true,
    validate: zodResolver(userInfo),
  });

  useEffect(() => {
    if (form.getValues().gender === undefined) {
      form.setFieldValue('gender', Gender.male);
      form.setDirty({ gender: false });
    } else {
      setIsValid(form.isValid());
    }
  }, [form]);

  const handleChange = () => {
    setIsValid(form.isValid());
  };

  const handleSubmit = async () => {
    try {
      await userDataStore.updateUserInfo(kcStore.token, form.getValues());
      window.history.back();
    } catch (error) {
      console.error(error);
      setDisplayError(true);
    }
  };

  return (
    <PageContainer>
      <ErrorModal
        opened={displayError}
        onClose={() => setDisplayError(false)}
      />
      <PageHeader
        title={t('common:contact_data_title')}
        message={t('profile:edit_health_data_message')}
      />
      <form
        onChange={handleChange}
        onSubmit={form.onSubmit(handleSubmit, console.log)}
      >
        <Flex direction={'column'} justify={'space-between'} h={'100%'}>
          <Stack classNames={{ root: classes.footerPadding }}>
            <Space h={0} />
            <NumberInput
              placeholder={t('body_height')}
              key={form.key('height')}
              {...form.getInputProps('height')}
            />
            <NumberInput
              placeholder={t('year_of_birth')}
              key={form.key('year_of_birth')}
              {...form.getInputProps('yearOfBirth')}
            />
            <SegmentedControl
              data={[
                { value: Gender.male, label: t('gender_male') },
                { value: Gender.female, label: t('gender_female') },
                { value: Gender.nonbinary, label: t('gender_other') },
              ]}
              key={form.key('gender')}
              {...form.getInputProps('gender')}
            />
            <TextInput
              placeholder={t('email')}
              key={form.key('email')}
              {...form.getInputProps('email')}
            />
          </Stack>
          <PageFooter
            leftOnClick={() => window.history.back()}
            buttonText={t('common:save_changes')}
            submitButton={true}
            disabled={!isValid}
          />
        </Flex>
      </form>
    </PageContainer>
  );
};
